export default __webpack_public_path__ + "static/media/080_finish_good.av1.2d6d2bba.mp4";